import { render, staticRenderFns } from "./Backmatter.vue?vue&type=template&id=ace3d660&"
import script from "./Backmatter.vue?vue&type=script&lang=js&"
export * from "./Backmatter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports